import React, { useEffect, useRef, useState } from "react";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import InputBox from "../../component/InputBox";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import { Controller, FormProvider, useForm } from "react-hook-form";
import classes from "./style.module.scss";
import moment from "moment";
import DateSelector from "../../component/DateSelector";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import { getDateFormat, singleUpload } from "../../helpers";
import FileUpload from "../../component/FileUpload";
import { applicationDropdown, subCategoryDropdown } from "../../helpers";
import { useNavigate } from "react-router-dom";
import GetUserPermission from "../../component/GetUserPermission";
import { CountryCode, getCountryCode } from '../../helpers';

const AddRewards = (props) => {
  const {
    isOpen = false,
    closePopUp,
    rewardId,
    handleSuccessModal,
    getRewardList,
  } = props;
  const ACTIVE = "Active";
  const IN_ACTIVE = "Inactive";
  const statusList = [
    { label: ACTIVE, value: ACTIVE },
    { label: IN_ACTIVE, value: IN_ACTIVE },
  ];
  const recipientList = [
    // { label: "Retailers", value: "1" },
    { label: "Mechanics", value: "2" },
    // { label: "Both", value: "3" },
  ];

  const [countryList, setCountryCodes] = useState([]);
    
      useEffect(() => {
        getCountryCode()
          ?.then((code) => {
            // Transform API data into your desired format
            const formattedCountries = code.map((item) => ({
              label: item.country_name,
              value: item.id,
            }));
    
            // Add the static "All" option at the beginning
            const allOption = { label: "All", value: 100 };
            const finalCountryList = [allOption, ...formattedCountries];
    
            // Set the final list in state
            setCountryCodes(finalCountryList);
          })
          .catch((err) => {
            console.error("Error fetching country codes:", err);
          });
      }, []);

  // const countryList = [
  //   { label: "All", value: 100 },
  //   { label: "India", value: 1 },
  //   { label: "UAE", value: 2 },
  //   { label: "Saudi", value: 3 },
  //   { label: "Jordan", value: 4 },
  //   { label: "Zambia", value: 5 },
  //   { label: "Nigeria", value: 6 },
  //   { label: "Kenya", value: 7 },
  //   { label: "Tanzania", value: 8 },
  // ];
  const selectBoxRef = useRef();
  const [isEdit, setIsEdit] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addPermission = GetUserPermission({ key: 'add', microAppPath: 'rewards' });
  const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'rewards' });

  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    trigger,
  } = formMethods;

  // const appDropdown = async () => {
  //   await applicationDropdown()
  //     .then((res) => {
  //       const formattedList = res.map((it) => ({
  //         label: it.title,
  //         value: it.id,
  //       }));
  //       setApplicationList(formattedList);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       Toast({
  //         type: "error",
  //         message: "Unable to process the request!..",
  //       });
  //     });
  // };

  useEffect(() => {
    if (isEdit) {
      if (!editPermission) {
        closePopUp()
        redirectBack()
      }
    } else {
      if (!addPermission) {
        closePopUp()
        redirectBack()
      }
    }
  }, [isEdit])

  useEffect(() => {
    if (rewardId) {
      getDetails(rewardId);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [rewardId]);

  const redirectBack = () => {
    navigate('')
  }

  const getDetails = async (id) => {
    let url = `${Exported.Endpoints.getRewardByID}/${id}`;
    let paramsObj = {
      id: id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data;
          let expiryDate = detailInfo?.expiry_date;
          setValue("rewardName", detailInfo?.title);
          setValue("producStatus", detailInfo?.status ? ACTIVE : IN_ACTIVE);
          setValue("rewardsDetails", detailInfo?.reward_details);
          setValue("recipient", detailInfo?.recipient);
          setValue("country_id", detailInfo?.country_id);
          setValue(
            "expiryDate",
            getDateFormat(expiryDate)?.format("YYYY-MM-DD")
          );
          setValue("pointsRequired", detailInfo?.points || 0);
          setValue("uploadResource", detailInfo?.image || null);
          setFileName([detailInfo?.image]);
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const onSubmit = async (data) => {
    trigger();
    dispatch(saveLoadingState(true));
    let uploadedObj = {};
    if (uploadedFiles && uploadedFiles.length > 0) {
      uploadedObj = await singleUpload(uploadedFiles);
    }
    let url = isEdit
      ? `${Exported.Endpoints.getRewardByID}/${rewardId}`
      : `${Exported.Endpoints.getRewardByID}`;
    let expiryDate = data?.expiryDate || new Date();
    let requestData = {
      title: data?.rewardName,
      points: data?.pointsRequired || 0,
      recipient: data?.recipient,
      country_id: data?.country_id,
      expiry_date: moment(expiryDate)?.format("YYYY-MM-DD"),
      reward_details: data?.rewardsDetails,
      status: data?.producStatus == ACTIVE ? true : false,
    };
    if (uploadedObj?.url) {
      requestData["image"] = uploadedObj?.url;
    }
    await request({
      url: url,
      method: isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
      data: requestData,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          handleSuccessModal();
          getRewardList();
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    dispatch(saveLoadingState(false));
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.addMembershipWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>
              {isEdit ? "Edit" : "Add"} Reward
            </div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Reward name"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"rewardName"}
                    isEdit={isEdit}
                    {...register("rewardName", {
                      required: true,
                    })}
                    placeholder={"Reward name"}
                    error={errors.rewardName}
                    messages={{
                      required: "Reward name is required",
                    }}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Points required"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"pointsRequired"}
                    isEdit={isEdit}
                    {...register("pointsRequired", {
                      required: true,
                      min: {
                        value: 100,
                        message: "Points must be 100 or greater",
                      },
                      valueAsNumber: true,
                      validate: (value) =>
                        value == 0 ||
                        Number(value) ||
                        "Points must be a number",
                    })}
                    placeholder={"Points required"}
                    error={errors.pointsRequired}
                    messages={{
                      required: "Points is required",
                      min: "Points must be 100 or greater",
                      validate: "Points must be a number",
                    }}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="producStatus"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Status"
                        placeholder="Status"
                        list={statusList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.producStatus}
                        messages={{
                          required: "Status is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="recipient"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Recipient"
                        placeholder="Recipient"
                        list={recipientList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.recipient}
                        messages={{
                          required: "Recipient is required",
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="country_id"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Country"
                        placeholder="Country"
                        list={countryList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.country_id}
                        messages={{
                          required: "Country is required",
                        }}
                      />
                    )}
                  />
                </div>
                {/* <div className={`${classes.formField}`}>
                  <Controller
                    name="applicationStatus"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Application ID"
                        placeholder="Application ID"
                        list={applicationList || []}
                        isEdit={isEdit}
                        multiple
                        {...field}
                        error={errors.applicationStatus}
                        messages={{
                          required: "Application ID is required",
                        }}
                      />
                    )}
                  />
                </div> */}
                <div className={`${classes.formField} !mb-5`}>
                  <DateSelector
                    className={`w-[100%]`}
                    label={'Expiry Date'}
                    name="expiryDate"
                    control={formMethods.control}
                    error={errors.expiryDate}
                    messages={{
                      required: "Expiry Date is required",
                      validate: "Date must be in YYYY-MM-DD format",
                    }}
                    minDate={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Rewards details"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"rewardsDetails"}
                    type={"textarea"}
                    isEdit={isEdit}
                    {...register("rewardsDetails", {
                      required: true,
                    })}
                    placeholder={"Rewards details"}
                    error={errors.rewardsDetails}
                    messages={{
                      required: "Rewards details is required",
                    }}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadResource"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadResource}
                    messages={{
                      required: "Resource file is required",
                    }}
                    maxSize={20971520}
                    maxLable= "20MB"
                    label="Upload File"
                    acceptFiles="image/png, image/jpg, image/jpeg"
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    isFileUploading={isFileUploading}
                    placeholder="Upload File (Max: 20 MB)"
                  />
                </div>
                <div className="flex justify-end">
                  <Button
                    text={"Save"}
                    className={`w-[100%] my-4`}
                    smallBtn
                    style={{ width: "120px" }}
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default AddRewards;
